module.exports = __webpack_public_path__ + "static/img/floor1-ht2.7501005.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor1-ht2.png
// module id = vW4A
// module chunks = 1